import React, { Component, Fragment } from 'react';
import { Form, Button } from 'react-bootstrap';
import Navigation from '../components/Navigation/Navigation';
import Loader from '../components/Global/Loader';
import LoaderSecondary from '../components/Global/LoaderSecondary';

class routeChangePassword extends Component {


    constructor(props) {
        super(props)
        this.state = {
            clientesLoading: false,
            clientes: false,
            validation: "needs-validation",
            modalValidacion: false,
            modal: false,
            buttonDisable: false,
            validationEntregar: false,
            changePassword: "",
            modalStateLoaded: false,
            modalStateText: "",
            modalState: false
        }

        this.obtenerClientes = this.obtenerClientes.bind(this);
        this.handleSeleccion = this.handleSeleccion.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.buscarUsuario = this.buscarUsuario.bind(this);
        this.modalOpen = this.modalOpen.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    handleChangePassword(e) {
        this.setState({ changePassword: e.target.value });
    }
    changePassword(e) {
        e.preventDefault();
        e.stopPropagation();
        this.modalOpen();
        this.setState({
            modal : true,
            modalStateLoading: true
        })
        console.log(this.state.usuarioDataD);
        var myHeaders = new Headers();
        myHeaders.append("Auth-Token", "zBKhfY9jXOUNVunScyIBltJJa3W1vg?HXsXPK5T1NCq1G!lXKN1ve9QOm25zIInZAQNgAK2VS7kTj7370NgqPg8w3DiQDb8AgtCCg6YNhU4wo45K!wEnOjPSnOtC8Rs");
        myHeaders.append("cliente", this.state.id_cliente);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch(window.$UrlOctavio + "/usuarios/" + this.state.usuarioDataD.id, requestOptions)
            .then(response => response.json())
            .then(result => {

                console.log(result)

                if (result.length === 0) {
                } else {
                    var myHeaders2 = new Headers();
                    myHeaders2.append("Auth-Token", "zBKhfY9jXOUNVunScyIBltJJa3W1vg?HXsXPK5T1NCq1G!lXKN1ve9QOm25zIInZAQNgAK2VS7kTj7370NgqPg8w3DiQDb8AgtCCg6YNhU4wo45K!wEnOjPSnOtC8Rs");
                    myHeaders2.append("cliente", this.state.id_cliente);
                    myHeaders2.append("Content-Type", "application/json");
                    var requestOptions2 = {
                        method: 'PATCH',
                        headers: myHeaders2,
                        redirect: 'follow',
                        body: JSON.stringify({
                            id: result.id,
                            tipo: result.tipo,
                            cliente: result.cliente,
                            nombre: result.nombre,
                            apellido: result.apellido,
                            email: result.email,
                            emailConfirmado: result.emailConfirmado,
                            juramentoFirmado: result.juramentoFirmado,
                            calle: result.calle,
                            idioma: result.idioma,
                            deudor: result.deudor,
                            idiomaDeCursado: result.idiomaDeCursado,
                            password: this.state.changePassword,
                        }),
                    };
                    fetch(window.$UrlOctavio + "/usuarios/" + this.state.usuarioDataD.id, requestOptions2)
                        .then(response => response.json())
                        .then(result => {
                            if (result.error) {
                                this.setState({
                                jsonChangePassword: null,
                                modal : true,
                                modalStateText: result.detalle,
                                modalStateLoaded: false,
                                modalStateLoading: false
                            })}
                            else{
                                this.setState({
                                    modal : true,
                                    modalStateText: "Contraseña modificada con éxito.",
                                    modalStateLoaded: true,
                                    modalStateLoading: false
                            })}

                        })
                        .catch(error => {
                            this.setState({
                                jsonChangePassword: null,
                                modal : true,
                                modalStateText: error.detalle,
                                modalStateLoaded: false,
                                modalStateLoading: false
                            })
                            console.log('error', error)
                        });
                }

            })
            .catch(error => {

                console.log('error', error)
            });


    }

    componentDidMount() {
        this.obtenerClientes();
    }

    obtenerClientes() {
        this.setState({
            clienteLoading: true
        })

        if (localStorage.getItem('clientes') !== null) {
            this.setState({
                clientes: JSON.parse(localStorage.getItem('clientes')),
                clienteLoading: false,
            })
        } else {
            var myHeaders = new Headers();
            myHeaders.append("Auth-Token", "zBKhfY9jXOUNVunScyIBltJJa3W1vg?HXsXPK5T1NCq1G!lXKN1ve9QOm25zIInZAQNgAK2VS7kTj7370NgqPg8w3DiQDb8AgtCCg6YNhU4wo45K!wEnOjPSnOtC8Rs");

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            fetch(window.$UrlOctavio + "/clientes", requestOptions)
                .then(response => response.json())
                .then(result => {
                    var clientes = [];

                    for (let i = 0; i < result.length; i++) {
                        clientes.push({
                            'id': result[i].id,
                            'dominio': result[i].dominio
                        })
                    }
                    this.setState({
                        clientes: clientes,
                        clienteLoading: false,
                    })
                })
                .catch(error => console.log('error', error));
        }
    }

    handleSeleccion(e) {
        const { value, name } = e.target;
        this.setState({
            [name]: value
        })
    }

    selecCliente() {
        if (this.state.clientes) {
            if (this.state.clientes.length === null || this.state.clientes.length === undefined) {
                return <LoaderSecondary></LoaderSecondary>
            } else {
                return <Fragment>
                    <select type="text" className="form-control mb-2" name="id_cliente" onChange={this.handleSeleccion} required>
                        <option value="">Selecciona el cliente</option>
                        {this.state.clientes.map(item => {
                            return <option key={`cliente${item.id}`} value={item.id}>{`${item.id} - ${item.dominio}`}</option>
                        })}
                    </select>
                    <input className="form-control ml-2 mr-2 mb-2" name="usuario" type="email" placeholder="Email de usuario" onChange={this.handleSeleccion} required />
                    <button className="btn btn-primary mb-2" onClick={this.buscarUsuario}>
                        Buscar
                    </button>
                </Fragment>
            }
        } else {
            return <LoaderSecondary></LoaderSecondary>
        }
    }

    handleValidation() {
        if (!this.state.id_cliente || !this.state.usuario) {
            return false;
        } else {
            return true;
        }
    }

    buscarUsuario(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.handleValidation() === true) {
            this.setState({
                validation: "needs-validation",
                usuarioData: false,
                comprasLoading: true
            })

            var myHeaders = new Headers();
            myHeaders.append("Auth-Token", "zBKhfY9jXOUNVunScyIBltJJa3W1vg?HXsXPK5T1NCq1G!lXKN1ve9QOm25zIInZAQNgAK2VS7kTj7370NgqPg8w3DiQDb8AgtCCg6YNhU4wo45K!wEnOjPSnOtC8Rs");
            myHeaders.append("cliente", this.state.id_cliente);
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            fetch(window.$UrlOctavio + "/usuarios?filter={\"email\":\"" + this.state.usuario + "\"}", requestOptions)
                .then(response => response.json())
                .then(result => {

                    // console.log(result[0])
                    console.log(result)

                    if (result.length === 0) {
                        this.setState({
                            usuarioData: null,
                            comprasLoading: null
                        })
                    } else {
                        this.setState({
                            usuarioData: true,
                            usuarioDataD: result[0],
                            idOctavio: result[0].id,
                            idCanvas: result[0].idCanvas,
                        })
                    }

                })
                .catch(error => {
                    this.setState({
                        usuarioData: null,
                        comprasLoading: null
                    })
                    console.log('error', error)
                });


        } else {
            this.setState({
                validation: "needs-validation was-validated",
            });
        }
    }

    usuarioData() {
        if (this.state.usuarioData === undefined) {
            return false
        } else {
            if (this.state.usuarioData === true) {
                return (
                    <Fragment>
                        <h4 className="global-title mb-3">Datos de usuario</h4>
                        <div className="box-white">

                            <ul className="list-group list-group-flush">
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <span>Apellido</span> <span className="ml-1"><b>{this.state.usuarioDataD.apellido}</b></span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <span>Nombre</span> <span className="ml-1"><b>{this.state.usuarioDataD.nombre}</b></span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <span>Email</span> <span className="ml-1"><b>{this.state.usuarioDataD.email}</b></span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    ID Octavio
                                    <span className="badge badge-secondary badge-pill">{this.state.usuarioDataD.id}</span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    ID Canvas
                                    <span className="badge badge-secondary badge-pill">{this.state.usuarioDataD.idCanvas}</span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    ID Hubspot
                                    <span className="badge badge-secondary badge-pill">{this.state.usuarioDataD.idHubspot}</span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    ID Magento
                                    <span className="badge badge-secondary badge-pill">{this.state.usuarioDataD.idMagento}</span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    ID Moodle
                                    <span className="badge badge-secondary badge-pill">{this.state.usuarioDataD.idMoodle}</span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <span>Idioma</span>
                                    <span className="badge badge-secondary badge-pill">{this.state.usuarioDataD.idioma}</span>
                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <span>Idioma de cursado</span>
                                    <span className="badge badge-secondary badge-pill">{this.state.usuarioDataD.idiomaDeCursado}</span>
                                </li>
                            </ul>
                        </div>
                    </Fragment>
                )
            } else if (this.state.usuarioData === false) {
                return <div className="box-white"><Loader></Loader></div>
            } else {
                return <div className="box-white"><p>No se encontró ningún usuario con la información proporcionada</p></div>
            }
        }

    }

    modalOpen() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
        if (this.state.modal === true) {
            this.setState({
                modaltexto: false
            })
        }
    }

    modalState() {
        if (this.state.modal === true) {
            return (
                <div className="custom-modal">
                    <div className="custom-modal-content">
                        <div className="custom-modal-header">
                            <div className="row d-flex justify-content-between align-items-center">
                                <div>
                                    <h6>Cambio de contraseña</h6>
                                </div>
                                <div>
                                    <button className="btn btn-close" onClick={this.modalOpen}>
                                        <i className="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="right-body bg-white text-center">
                            {this.state.modalStateLoading
                                ?
                                    <div className="right-footer d-flex justify-content-center align-items-stretch h-100">
                                        {/* <button disabled={this.state.buttonDisable} className="btn btn-primary mr-2" onClick={() => this.handleButtonShow()}> */}
                                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                            <span className="sr-only">Loading...</span>
                                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                            <span className="sr-only">Loading...</span>
                                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                            <span className="sr-only">Loading...</span>
                                            <span>Cargando...</span>
                                        {/* </button> */}
                                    </div>
                                :<div>
                                    {this.state.modalStateLoaded === true ?
                                        <i className="fa fa-check text-sussess fa-5x ml-auto mr-auto mb-2 mt-1 d-block"></i>
                                        :
                                        <i className="fa fa-times text-danger fa-5x ml-auto mr-auto mb-2 mt-1 d-block"></i>
                                    }
                                    <p>{this.state.modalStateText.charAt(0).toUpperCase() + this.state.modalStateText.slice(1)}</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            )
        }
    }

    renderChangePassword() {
        if (this.state.usuarioData === undefined) {
            return false
        } else {
            if (this.state.usuarioData === true) {
                return (
                    <Fragment>
                        <Form onSubmit={this.changePassword}>
                            <Form.Group controlId="formBasicEmail">
                                <Form.Label>Nueva Contraseña</Form.Label>
                                <Form.Control type="text" placeholder="Nueva contraseña" value={this.state.changePassword} onChange={this.handleChangePassword} />
                                    <Form.Text className="text-muted">Se recomienda utilizar Instancia+Año (Instancia2025)</Form.Text>
                                    <Form.Text className="text-muted">8 Carecteres</Form.Text>
                                    <Form.Text className="text-muted">Una mayuscula</Form.Text>
                                    <Form.Text className="text-muted">Una minuscula</Form.Text>
                                    <Form.Text className="text-muted">Un numero</Form.Text>
                            </Form.Group>
                            <Button variant="primary" type="submit">
                                Submit
                            </Button>
                        </Form>
                    </Fragment>
                )
            }
        }
    }


    render() {
        return (
            <React.Fragment>
                <Navigation />

                <div className="bg-light pt-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <label className="navigation-breadcrumb">Inicio / Cambio de Contraseña</label>
                                <h5>Cambio de contraseña</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="navbarstiky sticky-top bg-white mb-4 pb-3 pt-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                                <form action="" onSubmit={this.buscarUsuario} className={this.state.validation}>
                                    <div className="d-flex flex-column flex-xl-row flex-lg-row flex-md-row flex-sm-row justify-content-start align-items-center">
                                        {this.selecCliente()}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-3">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                            {this.usuarioData()}
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-2">
                            {this.renderChangePassword()}
                        </div>
                    </div>
                </div>

                { this.modalState() }
            </React.Fragment>
        )
    }

}

export default routeChangePassword;
